import { DigitalProductQuizQuizzesQuestionsInitial as Question } from '.'

export const SLUG = 'initial'
export const question = {
  SLUG,
  customContent: true,
  Component: Question
}
